import { render } from "./ViewsHelpdesk.vue?vue&type=template&id=af1f01a4"
import script from "./ViewsHelpdesk.vue?vue&type=script&lang=js"
export * from "./ViewsHelpdesk.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__